/* Club 1984 - drop page additions (October 2026): the tap-through and the
   five start lights. Both are extras; without this file the first picture
   still shows, the slides still swipe, and the lights stay unlit. */
(function () {
  'use strict';

  /* ---- tap-through ------------------------------------------------------ */
  document.querySelectorAll('[data-c84-pieces]').forEach(function (root) {
    var track = root.querySelector('[data-c84-pieces-track]');
    if (!track) return;
    var slides = track.children;
    var bars = root.querySelectorAll('[data-c84-pieces-bar]');
    var count = root.querySelector('[data-c84-pieces-count]');
    var total = slides.length;
    if (total < 2) return;
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    var current = 0;

    var show = function (i) {
      current = i;
      for (var b = 0; b < bars.length; b++) bars[b].classList.toggle('is-active', b === i);
      if (count) count.textContent = pad(i + 1) + ' / ' + pad(total);
    };
    var go = function (i) {
      i = (i + total) % total;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      show(i);
    };

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== current) show(Math.max(0, Math.min(total - 1, i)));
      }, 60);
    }, { passive: true });

    var prev = root.querySelector('[data-c84-pieces-prev]');
    var next = root.querySelector('[data-c84-pieces-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    bars.forEach(function (bar) {
      bar.addEventListener('click', function () { go(parseInt(bar.getAttribute('data-c84-pieces-bar'), 10) || 0); });
    });
    /* Keep the slide that was showing in place when the screen is resized or
       turned, instead of landing halfway between two. */
    window.addEventListener('resize', function () {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = current * track.clientWidth;
      track.style.scrollBehavior = '';
    });
  });

  /* ---- start lights ----------------------------------------------------- */
  /* One more light each day for the last five days: none at five days or more
     out, all five on the final day. The drop itself is "lights out" - the page
     reloads into the live state at that moment (club1984-drop.js). */
  document.querySelectorAll('[data-c84-lights]').forEach(function (row) {
    var scope = row.closest('.c84-drop__panel-inner') || document;
    var stamp = scope.querySelector('[data-c84-countdown]');
    var target = stamp ? Date.parse(stamp.getAttribute('data-c84-countdown')) : NaN;
    if (isNaN(target)) { row.hidden = true; return; }
    var dots = row.querySelectorAll('i');
    var paint = function () {
      var left = target - Date.now();
      var on = 0;
      if (left > 0) on = Math.max(0, Math.min(5, 5 - Math.floor(left / 86400000)));
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', i < on);
      row.setAttribute('aria-label', on + ' of 5 lights on');
    };
    paint();
    setInterval(paint, 60000);
  });
})();
